/*
 * This component is a card component for continuity across the app.
 *
 * @author Cargomatic Engineering
 * @usage <CargomaticCard />
 *
 */
import React, { forwardRef } from 'react';
import PropTypes from 'prop-types';
import { getClassName } from '../../utils/ui/classes';

const baseContainerClassNames = ['bg-white', 'rounded-lg', 'shadow'];

const CargomaticCard = forwardRef(
  (
    {
      children,
      grayBody,
      grayFooter,
      header,
      headerParams,
      footer,
      removeHorizontalPadding,
      removeVerticalPadding,
      className,
      removeBorders,
      dataTestId
    },
    ref,
  ) => {
    const bodyClassName = getClassName({
      'bg-gray-50': grayBody,
      'px-4': !removeHorizontalPadding,
      'sm:px-6': !removeHorizontalPadding,
      'py-4': !removeVerticalPadding,
      'sm:py-6': !removeVerticalPadding,
    });
    const footerClassName = getClassName('px-4', 'py-4', 'sm:px-6', {
      'bg-gray-50': grayFooter,
    });
    return (
      (<div
        data-testid={dataTestId}
        ref={ref}
        className={getClassName(
          baseContainerClassNames,
          {
            'divide-y': !removeBorders,
            'divide-gray-200': !removeBorders,
            'divide-solid': !removeBorders,
          },
          className,
        )}>
        {header && (
          <div data-testid="div-adc341f9" className="px-4 py-5 sm:px-6">{header(headerParams)}</div>
        )}
        {children && <div data-testid="div-3eda8b00" className={bodyClassName}>{children}</div>}
        {footer && <div data-testid="div-e3d56366" className={footerClassName}>{footer()}</div>}
      </div>)
    );
  },
);

CargomaticCard.propTypes = {
  children: PropTypes.any,
  header: PropTypes.func,
  headerParams: PropTypes.object,
  footer: PropTypes.func,
  grayBody: PropTypes.bool,
  grayFooter: PropTypes.bool,
  removeVerticalPadding: PropTypes.bool,
  removeHorizontalPadding: PropTypes.bool,
  removeBorders: PropTypes.bool,
  className: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.array,
    PropTypes.object,
  ]),
};

CargomaticCard.defaultProps = {
  grayBody: false,
  grayFooter: false,
  removeHorizontalPadding: false,
  removeVerticalPadding: false,
  removeBorders: false,
};

export default CargomaticCard;
